/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { optional as codecOptional, string as codecString } from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { JunitTestBaseData } from './JunitTestBaseData';
const JunitTestDataParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    [
        'wrapper',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ parsers.exactly('cg_check', 'cg_jest', 'cg_junit4', 'cg_junit5', 'cg_mocha', 'cg_moxunit', 'cg_phpunit', 'cg_pytest', 'cg_quickcheck', 'cg_semgrep', 'cg_xunit', 'custom')),
    ],
    [
        'metadata',
        /* #__PURE__ */ codecOptional(
        /* #__PURE__ */ codec.record(codecString, codec.unknown)),
    ],
]), JunitTestBaseData);
export class JunitTestData extends JunitTestBaseData {
    static decode(input) {
        return JunitTestDataParser.decode(input).map(res => new JunitTestData(res));
    }
    static unsafeDecode(input) {
        return JunitTestData.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return JunitTestDataParser.encode(data);
    }
    static schema() {
        return JunitTestDataParser.schema();
    }
}
